// Module
var code = "<input type=\"number\" ng-model=\"ngModel\" name=\"{{::inputName}}\" placeholder=\"{{::placeholder}}\"><div class=\"error-message\" ng-if=\"form.$submitted && !form[inputName].$valid\" translate=\"front_royal_form.inputs.validate_number.enter_a_number\" translate-values=\"{min: min, max: max}\"></div>";
// Exports
export default code;